export default {
  // widgetName: 'atk-player-dev',
  // widgetName: 'atk-player-staging',
  widgetName: 'atk-player',
  // apiHost: 'http://localhost:5000'
  // apiHost: 'https://atk-player-api-staging.audiotestkitchen.com'
  apiHost: 'https://atk-player-api.audiotestkitchen.com'
}
